<template>
  <v-container fluid class="container-full-bg-gray">
    <div>
    <app-page-card :isInModal="false" >
      <template #header >
        Alta de Bancos
      </template>
      <template #tabs-title class="title-tabs">
        <div class="px-8 pt-2 tabs-title-div-bck">
          <v-row align="center">
            <v-col cols="12" class="pt-0">
              <v-tabs v-model="currentTab">
                <v-tab key="manual">Manual</v-tab>
                <v-tab key="automatico">Automático</v-tab>
              </v-tabs>
            </v-col>
          </v-row>
        </div>
      </template>
      <template #header-actions>
        <v-toolbar flat dense>
          <app-btn
            color="primary"
            class="btn-save"
            :loading="loading_registration"
            :disabled="(currentTab=='0' && (!iban || !ownerName || !cuenta_bancos || !cuenta_partidas_abiertas || !institution || !country)) || (currentTab=='1' && (!institution || !country|| !cuenta_bancos || !cuenta_partidas_abiertas))"
            @click="registerBankAccount(false)"
          >
            Guardar
          </app-btn>
        </v-toolbar>
        <v-toolbar flat dense v-if="currentTab=='1' && userData.is_staff && provider_name!='afterbanks'">
          <app-btn
            color="primary"
            class="btn-save"
            :loading="loading_registration"
            :disabled="provider_name==''"
            @click="registerBankAccount(true)"
          >
            Usar Sandbox
          </app-btn>
        </v-toolbar>
      </template>
      <template>
        <v-tabs-items class="ma-2 pa-2" v-model="currentTab">
          <v-tab-item class="ma-0 pa-0" key="manual">
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="12" lg="4">
                <app-text-field
                  label="IBAN"
                  type="text"
                  v-model="iban"
                  >
                </app-text-field>
              </app-col>
              <app-col contains-input-fields cols="12" lg="4">
                <app-text-field
                  label="Nombre"
                  type="text"
                  v-model="ownerName"
                  >
                </app-text-field>
              </app-col>
              <app-col contains-input-fields cols="12" lg="4">
                <app-doc-text-field 
                  :kind="'account_am'"
                  :label="'Cuenta de bancos'" 
                  v-model="cuenta_bancos"
                  :is_array="true"
                  :items="accounts"
                  @get-values="getValues"
                  @reset-items="resetItems"
                  :error="cuenta_bancos_error"
                  :errorMessages="cuenta_bancos_error_msg"
                ></app-doc-text-field>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="12" lg="4">
                <app-doc-text-field 
                  :kind="'account_am'"
                  :label="'Cuenta de partidas abiertas'" 
                  v-model="cuenta_partidas_abiertas"
                  :is_array="true"
                  :items="accounts"
                  @get-values="getValues"
                  @reset-items="resetItems"
                  :error="cuenta_partidas_abiertas_error"
                  :errorMessages="cuenta_partidas_abiertas_error_msg"
                ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields cols="12" lg="4">
                <app-text-field
                  label="Institución"
                  type="text"
                  v-model="institution"
                  >
                </app-text-field>
              </app-col>
              <app-col contains-input-fields cols="12" lg="4">
                <app-autocomplete
                  class="ma-0 pa-0"
                  v-model="country"
                  :items="country_list"
                  label="País"
                  item-text="name"
                  item-value="id"
                  hide-no-data
                  hide-selected
                  hide-search
                  hide-details
                ></app-autocomplete>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="12" lg="4" v-if="got_feature('feature_use_different_currencies_in_banks')">
                <app-autocomplete
                  :items="available_currencies"
                  label="Divisa"
                  v-model="currency"
                  :disabled="!(available_currencies.length > 0)"
                  :loading="currency_loading"
                  hide-no-data
                  hide-selected
                  hide-search
                  hide-details
                ></app-autocomplete>
              </app-col>
            </app-row>
          </v-tab-item>
          
          <v-tab-item class="ma-0 pa-0" key="automatico">
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="12" lg="4">
                <app-autocomplete
                  :items="provider_list"
                  item-text="name"
                  item-value="id"
                  label="Proveedor"
                  v-model="provider_name"
                  hide-no-data
                  hide-selected
                  hide-search
                  hide-details
                  @change="reset_institution()"
                ></app-autocomplete>
              </app-col>
              <app-col contains-input-fields cols="12" lg="4">
                <app-autocomplete
                  :items="country_list"
                  item-text="name"
                  item-value="id"
                  label="País"
                  v-model="country"
                  @change="(event) => getInstitutions(event)"
                  :disabled="provider_name==''"
                  hide-no-data
                  hide-selected
                  hide-search
                  hide-details
                ></app-autocomplete>
              </app-col>
              <app-col contains-input-fields cols="12" lg="4">
                <app-autocomplete
                  :items="institution_list"
                  label="Institución"
                  v-model="institution"
                  :disabled="!(institution_list.length > 0) || provider_name==''"
                  :loading="institution_loading"
                  hide-no-data
                  hide-selected
                  hide-search
                  hide-details
                ></app-autocomplete>
              </app-col>
            </app-row>
            <app-row contains-input-fields>
              <app-col contains-input-fields cols="12" lg="4">
                <app-doc-text-field 
                  :kind="'account_am'"
                  :label="'Cuenta de bancos'" 
                  v-model="cuenta_bancos"
                  :is_array="true"
                  :items="accounts"
                  @get-values="getValues"
                  @reset-items="resetItems"
                  :disabled="provider_name==''"
                  :error="cuenta_bancos_error"
                  :errorMessages="cuenta_bancos_error_msg"
                ></app-doc-text-field>
              </app-col>
              <app-col contains-input-fields cols="12" lg="4">
                <app-doc-text-field 
                  :kind="'account_am'"
                  :label="'Cuenta de partidas abiertas'" 
                  v-model="cuenta_partidas_abiertas"
                  :is_array="true"
                  :items="accounts"
                  @get-values="getValues"
                  @reset-items="resetItems"
                  :disabled="provider_name==''"
                  :error="cuenta_partidas_abiertas_error"
                  :errorMessages="cuenta_partidas_abiertas_error_msg"
                ></app-doc-text-field>
              </app-col>
            </app-row>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </app-page-card>
  </div>
  </v-container>
</template>

<script>
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import AppBtn from '@/components/layout/AppBtn.vue';
import AppPageCard from '@/components/layout/AppPageCard.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import AppDocTextField from "@/components/layout/AppDocTextField.vue";
import AppAutocomplete from "@/components/layout/AppAutocomplete.vue";
import { InstitutionList } from "@/modules/bank/application/InstitutionList";
import { BankAccountCreation } from "@/modules/bank/application/BankAccountCreation";
import { GetCurrencyCodeListQuery } from "@/modules/invoices/app/GetCurrencyCodeListQuery";
import { query_dispatcher, sync_command_dispatcher, async_command_dispatcher} from "@/api/client";
import { mapGetters, mapState, mapActions } from "vuex"
import {v4 as uuidv4} from 'uuid';
import { mapFields } from 'vuex-map-fields';



export default {
  name: "BankCreation",
  components: {
    AppPageCard,
    AppBtn,
    AppCol, 
    AppRow,
    AppTextField,
    AppAutocomplete,
    AppDocTextField,
  },
  props: {
    
  },
  data() {
    return {
      currentTab:'manual',
      iban:'',
      ownerName:'',
      cuenta_bancos:'',
      cuenta_partidas_abiertas:'',
      institution:'',
      country:'',
      country_list: [
        {
          'id':'ES',
          'name':'España',
        },
      ],
      institution_list: [],
      original_institution_list: [],
      institution_loading: false,
      loading_registration: false,
      redirect_url:'',
      provider_name:'',
      provider_list: [
        // {
        //   'id':'enablebanking',
        //   'name':'Enable Banking',
        // },
        {
          'id':'gocardless',
          'name':'PSD2',
        }
      ],
      currency:'',
      currency_loading: false, 
      available_currencies: [],
      cuenta_partidas_abiertas_error: false,
      cuenta_partidas_abiertas_error_msg: '',
      cuenta_bancos_error: false,
      cuenta_bancos_error_msg: '',
    };
  },
  computed:{
    ...mapGetters({
      userData: "me/userData",
      currentCompany:"getCurrentCompany",
      got_feature:'got_feature',
    }),
    ...mapFields('cru', ['accounts']),
  },
  async mounted() {
    if (this.got_feature('feature_use_different_currencies_in_banks')) {
      this.currency_loading = true
      try {
        await new GetCurrencyCodeListQuery(query_dispatcher, this).run()
      } catch (error) {
        console.error('Error get currency code list', error);
      }
      this.currency_loading = false
    }
    if (this.got_feature('feature_can_use_multiple_bank_account_provider')) {
      this.provider_list.push({
        'id':'afterbanks',
        'name':'Avanzado',
      })
    }
  },
  methods: {
    ...mapActions("cru", ['getAccounts']),
    getValues(params) {
      this.getAccounts(params).then(() => {});
    },
    resetItems(params) {
      this.accounts = params;
    },
    async registerBankAccount(use_sandbox) {
      try {
        const new_id = uuidv4();
        this.loading_registration = true
        if (this.currency == '') {
          this.currency = 'EUR'
        }
        await new BankAccountCreation(sync_command_dispatcher, this).run(new_id, this.currentCompany.id, this.institution, 'ES', this.iban, this.ownerName, this.cuenta_bancos, this.cuenta_partidas_abiertas, this.currency, use_sandbox, this.provider_name);
        // this.redirect_to_url();
      } catch (error) {
        console.error('Error get link to create bank account', error);
      }
    },
    check_accounts() {
      let is_valid = true
      if(this.cuenta_bancos.length != this.currentCompany.num_digits){
        this.cuenta_bancos_error = true
        this.cuenta_bancos_error_msg = `La cuenta debe tener ${this.currentCompany.num_digits} caracteres`;
        is_valid = false;
      } else if (isNaN(this.cuenta_bancos)) {
        this.cuenta_bancos_error = true
        this.cuenta_bancos_error_msg = `La cuenta debe ser numérica`;
        is_valid = false;
      } else {
        this.cuenta_bancos_error_msg = '';
        this.cuenta_bancos_error = false
      }
      if(this.cuenta_partidas_abiertas.length != this.currentCompany.num_digits){
        this.cuenta_partidas_abiertas_error = true
        this.cuenta_partidas_abiertas_error_msg = `La cuenta debe tener ${this.currentCompany.num_digits} caracteres`;
        is_valid = false;
      } else if (isNaN(this.cuenta_partidas_abiertas)) {
        this.cuenta_partidas_abiertas_error = true
        this.cuenta_partidas_abiertas_error_msg = `La cuenta debe ser numérica`;
        is_valid = false;
      } else {
        this.cuenta_partidas_abiertas_error = false
        this.cuenta_partidas_abiertas_error_msg = '';
      }
      return is_valid
    },
    async getInstitutions(country_code) {
      try {
        await new InstitutionList(query_dispatcher, this).run('ES', this.provider_name, this.currentCompany.id)
        // this.institution_list = this.institution_list.map( item => { return item.name })
      } catch (error) {
        console.error('Error get institution list', error)
      }
    },
    reset_institution(){
      this.country = ''
      this.institution_list = []
      this.original_institution_list = []
    },
    redirect_to_url(){
      this.loading_registration = false
      window.location.href = this.redirect_url
    },
  },
};
</script>

<style lang="scss" scoped>

  .btn-save {
    font-size: 1.25rem; 
  }
  .tabs-title-div-bck {
    background: #F8F8FA !important;
  }

  .title-tabs {
    padding-bottom: 0px;
  }
  .items-tabs {
    margin-top: 0px !important;
  }
  ::v-deep .v-tabs-bar__content {
      background: #F8F8FA;
  }
  .v-tab {
      text-transform: capitalize !important;
      font-weight: 400;
      font-size: 18px;
  }
</style>
